import { ERROR, PENDING, SUCCESS } from "../globalStatuses/globalStatuses";
import whatsappTypes from "./whatsappTypes";

const initialState = {
    status: null,
    channels: null,
    routing: null,
    routingStatus: null,
    error: null,
};

export default function whatsappReducer(state = initialState, action) {
    switch (action.type) {
        case whatsappTypes.GET_CHANNELS_PENDING:
            return { ...state, status: PENDING, error: null };
        case whatsappTypes.GET_CHANNELS_SUCCESS:
            return {
                ...state,
                status: SUCCESS,
                channels: action.payload?.channels || {},
                routing: action.payload?.routing || {},
            };
        case whatsappTypes.GET_CHANNELS_ERROR:
            return { ...state, status: ERROR, error: action.error };

        case whatsappTypes.PUT_ROUTING_PENDING:
            return { ...state, routingStatus: PENDING };
        case whatsappTypes.PUT_ROUTING_SUCCESS:
            return {
                ...state,
                routingStatus: SUCCESS,
                routing: action.payload?.routing || state.routing,
            };
        case whatsappTypes.PUT_ROUTING_ERROR:
            return { ...state, routingStatus: ERROR, error: action.error };

        default:
            return state;
    }
}
